/*
 * @Author: Phoenix
 * @Date: 2020-05-01 10:56:51
 * @LastEditTime: 2021-01-18 17:32:24
 * @Description:
 * @FilePath: /ups-single-window-web/src/router/permission.js
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
 */
import store from '@/store'
import routesAdmin from '@/router/modules/admin'

export function hasAccess(permissionTag) {
  const userPermission = store.getters['user/userPermission']
  if (!Array.isArray(userPermission) || userPermission.length === 0) {
    return false
  }
  return userPermission.findIndex(v => v && v.permissionCode === permissionTag) > -1
}

export function nextPage(permissionTag) {
  const accessibleRoutes = []
  const collectAccessibleRoutes = (routes) => {
    routes.forEach(route => {
      if (route.meta && route.meta.permissionTag && hasAccess(route.meta.permissionTag)) {
        accessibleRoutes.push(route)
      }
      if (route.children) {
        collectAccessibleRoutes(route.children)
      }
    })
  }
  collectAccessibleRoutes(routesAdmin)

  const target =
    accessibleRoutes.find(v => v.meta.permissionTag !== permissionTag && v.path.startsWith('/')) ||
    accessibleRoutes.find(v => v.path.startsWith('/'))
  return target ? target.path : '/'
}
